import {
  SoccerEventStatusId,
  SoccerIncidentId,
  SoccerResultId,
} from '@collector/sportsapi-client-legacy'

import { PitchPenaltyOverlayConfig } from '../../configuration'

export const pitchPenaltyOverlayConfig: PitchPenaltyOverlayConfig<
  SoccerEventStatusId,
  SoccerResultId,
  SoccerIncidentId
> = {
  penaltyStatusId: SoccerEventStatusId.PenaltyShootout,
  penaltyResultId: SoccerResultId.Penalty,
  scoredPenaltyIncidentId: SoccerIncidentId.Goal,
  missedPenaltyIncidentId: SoccerIncidentId.MissedPenalty,
}
